import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'

import Icon from '@/client/components/_atoms/basic_icon'
import { useNavbarStore } from '@/client/store/useNavbarStore'

import BreadcrumbName from './BreadcrumbName.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarBreadcrumb',
  setup(__props) {

// @ts-nocheck TODO: 既存の型エラーを解消したら外す
const navbarStore = useNavbarStore()
const { breadcrumbs } = storeToRefs(navbarStore)

return { __sfc: true,navbarStore, breadcrumbs, Icon, BreadcrumbName }
}

})